import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import NavBar from "../layout/NavBar";
import "../styles/bills.css";
import "../App.css";
import { useTable } from "react-table";
import { useDebounce } from "../Hooks/Hooks";
import { http } from "../auth";
import { Col, Row, Form, Spinner, Overlay, Popover } from "react-bootstrap";
import Table from "../components/Table";
import { MdCreditCard } from "react-icons/md";
import { IoDocumentText } from "react-icons/io5";
import { LuFilter } from "react-icons/lu";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useThemeManager } from "../Hooks/ThemeManager";
import { TiDeleteOutline } from "react-icons/ti";

/*-----Iconos-----*/
import { FaSearch } from "react-icons/fa";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdFileDownload,
  MdRemoveRedEye,
  MdSettingsBackupRestore,
} from "react-icons/md";
import { ThemeContext } from "../App";
import RetencionModal from "../components/RetencionModal";

const Bills = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingIcon, setLoadingIcon] = useState({});
  const [loadingIconView, setLoadingIconView] = useState({});
  const [search, setSearch] = useState("");
  const [estado, setEstado] = useState("");
  const [date, setDate] = useState("ALL");
  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);
  const token = localStorage.getItem("token");
  const searchDelay = useDebounce(search, 800);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [show, setShow] = useState(false);
  const [fileBase64, setFileBase64] = useState(null);
  const [fileName, setFileName] = useState("");
  const [tipo, setTipo] = useState("FACT");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [mimetype, setMimetype] = useState("");
  const [loadingRows, setLoadingRows] = useState(new Set());
  const { themeColors } = useThemeManager();
  const [showPopover, setShowPopover] = useState(false);
  const popoverTarget = useRef(null);

  const handleShow = (rowData) => {
    setShow(true);
    setSelectedRowData(rowData);
  };

  const fetchData = () => {
    setLoading(true);
    setData([]);

    const params = {
      tipo,
      page: currentPage,
      col: "__all__",
      ...(search && { q: search }),
      ...(estado && { estado }),
      ...(fechaDesde && { date: fechaDesde }),
      ...(fechaHasta && { date2: fechaHasta }),
    };

    http
      .get(`/intranet-j/documentos`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setData(response.data);
        setTotalPages(response.data.pages);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error en la solicitud:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page, date, searchDelay, estado, tipo, fechaDesde, fechaHasta]);

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getExtension = (contentType) => {
    const map = {
      "application/pdf": ".pdf",
      "image/png": ".png",
      "image/jpeg": ".jpg",
      "image/jpg": ".jpg",
    };
    return Object.entries(map).find(([key]) => contentType.includes(key))?.[1] || "";
  };

  const handleDownload = async (id, numeroFactura) => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    setLoadingIcon((prev) => ({ ...prev, [id]: true }));

    try {
      const response = await http.get(`/intranet-j/documento-descargar/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const contentType = response.headers?.["content-type"] || "application/pdf";
      const ext = getExtension(contentType);
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `factura_${numeroFactura}${ext}`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    } finally {
      setLoadingIcon((prevState) => ({ ...prevState, [id]: false }));
    }
  };

  const handleDownloadRetencion = async (id, numeroFactura) => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    setLoadingIcon((prev) => ({ ...prev, [id]: true }));

    try {
      const response = await http.get(`/intranet-j/retenciones/${id}/ver`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const contentType = response.headers?.["content-type"] || "application/pdf";
      const ext = getExtension(contentType);
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `comprobante_${numeroFactura}${ext}`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    } finally {
      setLoadingIcon((prevState) => ({ ...prevState, [id]: false }));
    }
  };

  const handleViewRetencion = async (id) => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    setLoadingIconView((prev) => ({ ...prev, [id]: true }));

    try {
      const response = await http.get(`/intranet-j/retenciones/${id}/ver`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      const contentType = response.headers?.["content-type"] || "application/pdf";
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      setLoadingIcon(false);
      if (!newWindow) {
        throw new Error("No se pudo abrir una nueva ventana para ver la factura.");
      }
    } catch (error) {
      setLoadingIcon(false);
      console.error("Error al ver la factura:", error);
    } finally {
      setLoadingIconView((prevState) => ({ ...prevState, [id]: false }));
    }
  };

  const handleAnular = async (id) => {
    const confirmar = window.confirm("¿Está seguro de que desea anular esta retención?");

    if (!confirmar) {
      return;
    }

    try {
      const response = await http(`/intranet-j/retenciones/${id}/anular`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Documento anulado");
    } catch (error) {
      console.error("Error al conectar con el servidor:", error);
      toast.error("Hubo un problema al intentar anular el documento");
    }
  };

  const handleView = async (id) => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    setLoadingIconView((prev) => ({ ...prev, [id]: true }));

    try {
      const response = await http.get(`/intranet-j/documento-descargar/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      const contentType = response.headers?.["content-type"] || "application/pdf";
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (!newWindow) {
        throw new Error("No se pudo abrir una nueva ventana para ver la factura.");
      }
    } catch (error) {
      console.error("Error al ver la factura:", error);
    } finally {
      setLoadingIconView((prevState) => ({ ...prevState, [id]: false }));
    }
  };

  const columns = React.useMemo(
  () => [
    {
      Header: "ID",
      accessor: "id",
      width: 100,
      Cell: () => null,
    },
    {
      Header: () => (tipo === "RETE" ? "N° Comprobante" : "N° Documento"),
      accessor: "nro_fac",
      width: 100,
      Cell: ({ value, row }) => (
        <div className="table-cell">
          {row.original?.tipo_doc === "PROF" ? String(row.original.id).padStart(8, "0") : value}
        </div>
      ),
    },
    {
      Header: "Tipo",
      accessor: "tipo",
      width: 100,
      Cell: ({ value }) => <div className="table-cell"> {value ? value.toUpperCase() : ""}</div>,
      show: tipo === "RETE",
    },
    {
      Header: () => (tipo === "RETE" ? "N° Control de factura" : "N° Control"),
      accessor: "nro_ctl",
      width: 100,
      Cell: ({ value }) => <div className="table-cell">{value}</div>, // Quité ms-4
    },
    {
      Header: "Estado",
      accessor: "estado",
      width: 100,
      Cell: ({ value }) => {
        let bgColor;
        let textColor = "#fff";
        switch (value) {
          case "completada":
            bgColor = "#063b82";
            break;
          case "faltan retenciones":
            bgColor = "#063b82";
            break;
          case "verificada":
          case "pendiente":
          case "por pagar":
            bgColor = "#0f73fd";
            break;
          case "anulada":
          case "sin retenciones":
            bgColor = "#d12828";
            break;
          case "retenciones pendientes":
            bgColor = "#d12828";
            break;
          case "por validar":
            bgColor = "#facb0c";
            textColor = "#000";
            break;
          case "aprobada":
            bgColor = "#198754";
            break;
          default:
            bgColor = "#f0f0f0";
        }

        return (
          <div
            className="table-cell bg-status"
            style={{
              backgroundColor: bgColor,
              padding: "2px 8px",
              borderRadius: "4px",
              color: textColor,
              display: "inline-block",
              textAlign: "center",
              minWidth: "120px"
            }}
          >
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </div>
        );
      },
    },
    {
      Header: "Fecha",
      accessor: "fecha_emi",
      width: 100,
      Cell: ({ value }) => {
        const fecha = new Date(value);
        const formattedDate = `${String(fecha.getDate()).padStart(2, "0")}/${String(fecha.getMonth() + 1).padStart(
          2,
          "0",
        )}/${fecha.getFullYear()}`;
        return <div className="table-cell">{formattedDate}</div>; // Quité ms-5
      },
    },
    {
      Header: "Total Neto",
      accessor: "total_neto",
      width: 100,
      Cell: ({ value, row }) => (
        <div className="table-cell">
          {tipo === "FACT" || tipo === "PROF" ? value : ""}
          {tipo === "RETE" ? row.original.monto : ""}
          {tipo === "PROF" ? " $" : " Bs"}
        </div> // Quité ms-3
      ),
    },
    {
      Header: "Opciones",
      width: 150,
      Cell: ({ row }) => (
        <div className="table-cell d-flex align-items-center justify-content-center gap-3"> {/* gap-3 para mejor espaciado */}
          {/* Icono 1: Documento */}
          {row.original?.tipo_doc !== "PROF" && (
            row.values.estado === "faltan retenciones" ||
            row.values.estado === "sin retenciones" ||
            row.values.estado === "por validar" ||
            row.values.estado === "sin cargar" ||
            row.values.estado === "completada"
          ) ? (
            <div className="position-relative d-inline-block">
              <div className="tooltip-wrapper">
                <div className="d-inline-flex align-items-center">
                  <IoDocumentText
                    size={20}
                    onClick={() => handleShow(row.original)}
                    className="color-primary cursor"
                  />
                </div>
                <span className="tooltip-content">Ver documento</span>
              </div>
              {row.values.estado === "sin retenciones" ? (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger badge-xs"
                >
                  {row.original?.retenciones?.length}
                </span>
              ) : row.original?.retenciones?.length > 0 && row.values.estado !== "completada" ? (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger badge-xs"
                >
                  {row.original?.retenciones?.length > 99 ? "99+" : row.original?.retenciones?.length}
                </span>
              ) : null}
            </div>
          ) : null}

          {/* Icono 2: Tarjeta de crédito */}
          {row.values.estado === "por pagar" &&
            row.values.estado !== "faltan retenciones" &&
            row.values.estado !== "sin cargar" ? (
<div className="tooltip-wrapper">
                <div className="d-inline-flex align-items-center">
                  <Link to="/pago">
                    <MdCreditCard size={20} className="cursor icon-green" />
                  </Link>
                </div>
                <span className="tooltip-content">Ir a pagar</span>
              </div>
          ) : null}

          {/* Icono 3: Descarga/Spinner */}
          {loadingIcon[row.values.id] ? (
            <Spinner animation="border" className="color-primary spinner-sm" />
          ) : (
<div className="tooltip-wrapper">
                <div className="d-inline-flex align-items-center">
                  <MdFileDownload
                    size={20}
                    onClick={() =>
                      tipo === "RETE"
                        ? handleDownloadRetencion(row.values.id, row.values.nro_fac)
                        : handleDownload(row.values.id, row.values.nro_fac)
                    }
                    className="color-secondary cursor"
                  />
                </div>
                <span className="tooltip-content">Descargar</span>
              </div>
          )}

          {/* Icono 4: Ojo */}
          {loadingIconView[row.values.id] ? (
            <Spinner animation="border" className="color-primary spinner-sm" />
          ) : (
<div className="tooltip-wrapper">
                <div className="d-inline-flex align-items-center">
                  <MdRemoveRedEye
                    size={20}
                    onClick={() => (tipo === "RETE" ? handleViewRetencion(row.values.id) : handleView(row.values.id))}
                    className="color-secondary cursor"
                  />
                </div>
                <span className="tooltip-content">Ver detalle</span>
              </div>
          )}

          {/* Icono 5: Eliminar (solo para RETE pendiente) */}
          {tipo === "RETE" && row.values.estado === "pendiente" ? (
<div className="tooltip-wrapper">
                <div className="d-inline-flex align-items-center">
                  <TiDeleteOutline
                    size={20}
                    onClick={() => handleAnular(row.values.id)}
                    className="cursor icon-red"
                  />
                </div>
                <span className="tooltip-content">Anular</span>
              </div>
          ) : null}
        </div>
      ),
    },
  ],
  [tipo, themeColors, loadingIcon, loadingIconView],
);

  const table = useTable({
    columns,
    data: data.data || [],
    initialState: {
      hiddenColumns: columns.map((column) => {
        if (column.accessor === "id" || column.show === false) return column.accessor || column.id;
      }),
    },
  });

  return (
    <div className="contenedorBills">
      <div className="bills">
        <div className="billsHeader color-secondary">
          <div className="billTitulo">Registro de Documentos</div>
          <div className="billFiltro">
            <div className="me-3 mb-3">
              <select
                className="input-tipo color-primary"
                aria-label="Seleccionar tipo de documento"
                onChange={(e) => {
                  setTipo(e.target.value);
                }}
              >
                <option value="FACT">Facturas</option>
                <option value="PROF">Proforma</option>
                <option value="RETE">Retenciones</option>
              </select>
            </div>
            <div className="filtr mb-3">
              <span
                className="buttonSearch color-primary"
                onClick={() => {
                  fetchData();
                }}
              >
                <FaSearch />
              </span>
              <input
                className="formInputBill color-primary"
                type="text"
                placeholder="Buscador"
                onChange={handleSearch}
              />
            </div>
            <div className="filtr">
              <div
                className="filtro-table color-primary"
                id="popover-button"
                ref={popoverTarget}
                onClick={() => setShowPopover(!showPopover)}
              >
                <div>
                  <LuFilter className="icon-filtro" />
                </div>
                <div className="ms-1">
                  <span>Filtros</span>
                </div>
              </div>
            </div>

            {/* Popover de Filtros */}
            <Overlay
              show={showPopover}
              target={popoverTarget.current}
              placement="bottom-end"
              rootClose
              onHide={() => setShowPopover(false)}
              transition={false}
              container={document.body}
            >
              <Popover
                id="filter-popover"
                className="custom-menu"
                style={{
                  backgroundColor: themeColors.background,
                  border: '1px solid var(--primary-color)',
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  minWidth: "300px",
                  zIndex: 9999,
                }}
              >
                <Popover.Body className="p-3">
                  <div className="filter-popover-content">
                    <div className="title-filter d-flex justify-content-between align-items-center">
                      <span className="color-secondary fw-bold">Más filtros</span>
                      <MdSettingsBackupRestore
                        className="color-primary restore-icon"
                        onClick={() => {
                          setCurrentPage(1);
                          setTipo("FACT");
                          setEstado("");
                          setSearch("");
                          setFechaDesde(null);
                          setFechaHasta(null);
                          setShowPopover(false);
                        }}
                      />
                    </div>

                    <div className="body-filter color-secondary">
                      <span className="mb-3 d-block">Estados</span>
                      <Row className="d-flex justify-content-center">
                        {tipo !== "RETE" && (
                          <>
                            <Row>
                              <Col xs={6}>
                                <Form.Check
                                  className="custom-radio"
                                  type="radio"
                                  id="cerrado"
                                  label={
                                    <label htmlFor="cerrado" className="cursor ms-2">
                                      Completada
                                    </label>
                                  }
                                  checked={estado === "cerrado"}
                                  onChange={() => {
                                    setEstado("cerrado");
                                    setCurrentPage(1);
                                  }}
                                />
                              </Col>
                              <Col xs={6}>
                                <Form.Check
                                  className="custom-radio"
                                  type="radio"
                                  id="abierto"
                                  label={
                                    <label htmlFor="abierto" className="cursor ms-2">
                                      Por completar
                                    </label>
                                  }
                                  checked={estado === "abierto"}
                                  onChange={() => {
                                    setEstado("abierto");
                                    setCurrentPage(1);
                                  }}
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                        {tipo === "RETE" && (
                          <>
                            <Row>
                              <Col xs={6}>
                                <Form.Check
                                  className="custom-radio"
                                  type="radio"
                                  id="pendiente"
                                  label={
                                    <label htmlFor="pendiente" className="cursor ms-2">
                                      Pendiente
                                    </label>
                                  }
                                  checked={estado === "pendiente"}
                                  onChange={() => {
                                    setEstado("pendiente");
                                    setCurrentPage(1);
                                  }}
                                />
                              </Col>
                              <Col xs={6}>
                                <Form.Check
                                  className="custom-radio"
                                  type="radio"
                                  id="aprobada"
                                  label={
                                    <label htmlFor="aprobada" className="cursor ms-2">
                                      Aprobada
                                    </label>
                                  }
                                  checked={estado === "aprobada"}
                                  onChange={() => {
                                    setEstado("aprobada");
                                    setCurrentPage(1);
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6}>
                                <Form.Check
                                  className="custom-radio"
                                  type="radio"
                                  id="verificada"
                                  label={
                                    <label htmlFor="verificada" className="cursor ms-2">
                                      Verificada
                                    </label>
                                  }
                                  checked={estado === "verificada"}
                                  onChange={() => {
                                    setEstado("verificada");
                                    setCurrentPage(1);
                                  }}
                                />
                              </Col>
                              <Col xs={6}>
                                <Form.Check
                                  className="custom-radio"
                                  type="radio"
                                  id="anulada"
                                  label={
                                    <label htmlFor="anulada" className="cursor ms-2">
                                      Anulada
                                    </label>
                                  }
                                  checked={estado === "anulada"}
                                  onChange={() => {
                                    setEstado("anulada");
                                    setCurrentPage(1);
                                  }}
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                      </Row>

                      <Row className="mt-3">
                        <Col xs={12} sm={6}>
                          <Form.Group controlId="fechaDesde">
                            <Form.Label>Desde</Form.Label>
                            <Form.Control
                              type="date"
                              name="desde"
                              className="custom-input color-primary"
                              value={fechaDesde || ""}
                              onChange={(e) => setFechaDesde(e.target.value)}
                              lang="es"
                              style={{
                                border: '1px solid var(--secondary-color)',
                                backgroundColor: "transparent",
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={12} sm={6}>
                          <Form.Group controlId="fechaHasta">
                            <Form.Label>Hasta</Form.Label>
                            <Form.Control
                              type="date"
                              name="hasta"
                              className="custom-input color-primary"
                              value={fechaHasta || ""}
                              onChange={(e) => setFechaHasta(e.target.value)}
                              lang="es"
                              style={{
                                border: '1px solid var(--secondary-color)',
                                backgroundColor: "transparent",
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </div>
        <div className="billsBody">
          <Table table={table} height={false} loading={loading} className="table-dark-mode" />
          <div
            className="d-flex flex-row justify-content-end mt-2 align-items-center color-secondary"
          >
            <p className="mb-0 me-3">
              {currentPage} de {totalPages}{" "}
            </p>
            <MdKeyboardArrowLeft
              className="me-3 pagination-icon"
              onClick={handlePrevPage}
            />
            <MdKeyboardArrowRight className="pagination-icon" onClick={handleNextPage} />
          </div>
        </div>
      </div>

      <RetencionModal
        data={selectedRowData}
        show={show}
        onHide={() => {
          setShow(false);
        }}
        onUpdate={() => fetchData()}
      />
    </div>
  );
};

export default Bills;
